import type { IconData } from '@stacksjs/iconify-core'

export const devicesLaptop: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 1h13v10l1.5 4H0l1.5-4zM10 11H6v2h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesLaptop
